import { calendarHtml } from '../lib/calendar'

const html = calendarHtml()

export function Calendar() {
  return <div className="cal-wrap" dangerouslySetInnerHTML={{ __html: html }} />
}
